import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { saveStep2Callback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import {
  workflowDetails,
  workflowValidStep2State
} from 'Pages/Workflow/recoil/state/data'
import { pageState, wizardSteps } from 'Pages/Workflow/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()

  const { Draft } = useRecoilValue(workflowDetails)
  const step2Valid = useRecoilValue(workflowValidStep2State)
  const setWizardStep = useSetRecoilState(wizardSteps)
  const saveStep2 = useRecoilCallback(saveStep2Callback, [])
  const [{ edit, saveAndExit }, setPageState] = useRecoilState(pageState)

  const handleBack = () => {
    setWizardStep((prev) => ({ ...prev, wizardStep: 1 }))
  }

  const exit = () => {
    setPageState((prev) => ({
      ...prev,
      isDirty: false,
      saveAndExit: true
    }))
  }

  useEffect(() => {
    saveAndExit &&
      history.push(`/automation/workflows/list?saved=1&edit=${edit ? 1 : 0}`)
  }, [saveAndExit])

  const handleSaveExit = () => {
    saveStep2({ onSuccess: exit })
  }

  return (
    <Flex justifyContent='space-between' width='100%'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        data-mu-test='back'
        onClick={handleBack}
      >
        {intl.formatMessage({ id: 'Load.AutomationWorkflow.PrevStepButton' })}
      </Button>

      <Flex columnGap='8px'>
        {Draft && (
          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            data-mu-test='save-exit'
            onClick={handleSaveExit}
          >
            {intl.formatMessage({ id: 'Load.AutomationWorkflow.Draft' })}
          </Button>
        )}
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            data-mu-test='next'
            onClick={saveStep2}
            disabled={!step2Valid}
          >
            {intl.formatMessage({
              id: 'Load.AutomationWorkflow.NextStepButton'
            })}
          </Button>
        </FlexItem>
      </Flex>
    </Flex>
  )
}

export default Footer
